import React from "react"
import {
    FormErrorMessage,
    FormLabel,
    FormControl,
    Input,
    InputGroup,
    background,
    Checkbox,

} from "@chakra-ui/react";
import {
    OptionBase,
    ChakraStylesConfig,
    Select,
    chakraComponents,
    GroupBase,
    SelectComponentsConfig,
    OptionProps
} from "chakra-react-select";
import type { Props, SelectInstance } from "react-select";
import { User } from "types";

export interface UserOption extends OptionBase {
    label: string;
    value: string;
    user: User;
    main?: boolean;
}

interface UIProps {
    label: string;
    name: any;
    hideLabel?: boolean;
    errorMessage?: string;
}


type DropDownProps = UIProps & Props

// Make sure this is defined outside of the component which returns your select
// or you'll run into rendering issues
const customComponents = {
    Option: (props: OptionProps) => (
        <chakraComponents.Option {...props}>
            <Checkbox colorScheme="blue" isChecked={props.isSelected}> </Checkbox> {`${props.children}`}
        </chakraComponents.Option>
    ),
};

const DropdownMultiSearch: React.FC<DropDownProps> = ({
    name,
    label,
    hideLabel,
    errorMessage,
    ...rest
}) => {

    const chakraStyles: ChakraStylesConfig = {
        option: (provided, state) => ({ //Actual select options in the container box
            ...provided,
            color: state.isFocused ? "#2F3243" : "#FFFFFF",
            fontsize: "16px",
            ...(state.isSelected && {
                backgroundColor: "#505263",
                color: "#FFFFFF"
            })
        }),
        menuList: (provided, state) => ({ //options container box
            ...provided,
            backgroundColor: "#505263",
        }),
        multiValue: (provided, state) => ({ //Values shown in the box when selected
            ...provided,
            backgroundColor: "#707388",
            color: "#FFFFFF",
            minBlockSize: "40px",
            rounded: "20px",
        }),
        control: (provided, state) => ({ //Box component of the whole select
            ...provided,
            minWidth: "396px",
            minHeight: "5px",
        }),
        dropdownIndicator: (provided, { selectProps }) => ({ //That little down arrow thing
            ...provided,
            "> svg": {
                transform: `rotate(${selectProps.menuIsOpen ? -180 : 0}deg)`,
            },
        }),
        multiValueRemove: (provided, state) => ({ //Box component of the whole select
            ...provided,
            color: "#FFFFFF",
            backgroundColor: "#00BFF3",
        }),
    };


    return (
        <FormControl isInvalid={!!errorMessage} width="100%">
            <FormLabel htmlFor={name} fontSize="sm" hidden={hideLabel}>
                {label}
            </FormLabel>
            <InputGroup>
                <Select
                    chakraStyles={chakraStyles}
                    components={customComponents}
                    {...rest} />
            </InputGroup>
            <FormErrorMessage>{errorMessage && errorMessage}</FormErrorMessage>
        </FormControl>
    );
}

export default DropdownMultiSearch;